<template>
  <div class="footer">
    <div class="footer__services">
      <div class="footer__services-item" @click="openBird">
        <div class="birdeye" />
      </div>
      <div class="footer__services-item" @click="openCookiefun">
        <div class="cookiefun" />
      </div>
      <div class="footer__services-item" @click="openDextools">
        <div class="dextools" />
      </div>
      <div class="footer__services-item" @click="openGecko">
        <div class="geckoterminal" />
      </div>
      <div class="footer__services-item" @click="openDexsc">
        <div class="dexscr" />
      </div>
    </div>
    <div class="footer__info">
      <div class="name">Schrödinger</div>
      <div class="copyright">© 2025. All rights reserved. The art by Pierre Bonnard</div>
    </div>
  </div>
</template>
<script>
export default {
  setup() {
    const openBird = () => {
      window.open('https://www.birdeye.so/token/8ELspwRkgbz122WrdaX6pfHspHnLFU51jAKuP15cpump?chain=solana', '_blank');
    };

    const openDextools = () => {
      window.open('https://www.dextools.io/app/en/token/aischrodinger?t=1737096798651', '_blank');
    };

    const openCookiefun = () => {
      window.open('https://www.cookie.fun/en/agent/schrodinger', '_blank');
    };

    const openDexsc = () => {
      window.open('https://dexscreener.com/solana/drh4kfvgeklgg2mbwprxezn6pod5jeib3sbx4srxbqv5', '_blank');      
    }

    const openGecko = () => {
      window.open('https://www.geckoterminal.com/solana/pools/DrH4KfVGEKLgG2mbWpRXeZn6poD5jEiB3SBx4SRXBQv5', '_blank');
    }

    return {
      openBird,
      openDexsc,
      openDextools,
      openCookiefun,
      openGecko,
    }
  },
}
</script>
<style lang="scss" scoped>
  .footer {
    font-family: 'YoungSerif-Regular';
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: clamp(20px, 4vw, 40px) 0 clamp(10px, 2vw, 20px);
    padding-top: clamp(15px, 2.5vw, 25px);
    border-top: 1px solid rgba(0, 0, 0, 0.05);

    &__services {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 30px;
      flex-wrap: wrap;
      gap: clamp(10px, 1.5vw, 15px);
    }

    &__services-item {
      width: min(220px, 22vw);
      height: clamp(40px, 5vw, 50px);
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: $controlRadius;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
        border-color: rgba(0, 0, 0, 0.2);
      }

      display: flex;
      justify-content: center;
      align-items: center;

      .birdeye {
        width: 120px;
        height: 24px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/birdeye.svg");
        background-size: contain;
        background-position: center;
      }

      .cookiefun {
        width: 120px;
        height: 24px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/cookiefun.svg");
        background-size: contain;
        background-position: center;
      }

      .dextools {
        width: 90px;
        height: 24px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/dextools.svg");
        background-size: contain;
        background-position: center;
      }
      
      .geckoterminal {
        width: 140px;
        height: 24px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/geckoterminal.svg");
        background-size: contain;
        background-position: center;
      }

      .dexscr {
        width: 140px;
        height: 24px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/dexscr.svg");
        background-size: contain;
        background-position: center;
      }
    }

    &__info {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      justify-content: center;
      margin-top: 10px;

      .name {
        font-size: 18px;
        color: $textBlack;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .copyright {
        font-size: 14px;
        color: #7C7B7B;
        font-weight: 500;
      }
    }

    @media (min-width: 769px) and (max-width: 1024px) {
      &__services-item {
        width: 170px;
        height: 45px;
        
        .birdeye, .cookiefun, .dextools, .geckoterminal, .dexscr {
          width: 100px;
          height: 22px;
        }
      }
      
      &__info {
        .name {
          font-size: 17px;
        }
        
        .copyright {
          font-size: 13px;
        }
      }
    }

    @media (max-width: 768px) {
      &__services-item {
        width: 48px;
        height: 48px;

        .birdeye, .cookiefun, .dextools, .geckoterminal, .dexscr {
          width: 28px;
          height: 28px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }

        .birdeye {
          background-image: url("~@/assets/icons/birdeye-mob.svg");
        }

        .cookiefun {
          background-image: url("~@/assets/icons/cookiefun-mob.svg");
        }

        .dextools {
          background-image: url("~@/assets/icons/dextools-mob.svg");
        }
        
        .geckoterminal {
          background-image: url("~@/assets/icons/geckoterminal-mob.svg");
        }

        .dexscr {
          background-image: url("~@/assets/icons/dexscr-mob.svg");
        }
      }

      &__info {
        .name {
          font-size: 18px;
        }

        .copyright {
          font-size: 12px;
        }
      }
    }
  }
</style>

